export default "__VITE_ASSET__hp00OUIK__"